module.exports = __webpack_public_path__ + "img/10n.e5d3aef1.svg";